module.exports = __webpack_public_path__ + "static/img/David.Myers.a745ee6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/David.Myers.jpg
// module id = rKhO
// module chunks = 0